/**
 * The quotes module's assistant views (design D18), registered in
 * `registry.ts` like `crmAgentViews`: `quote_preview`, the read-only
 * replica of a quote the assistant shows before the user confirms it.
 */
import { QuotePreviewView } from "./QuotePreviewView.js";
import { isQuotePreviewView } from "./quotePreviewSpec.js";
import type { AgentViewComponent } from "./registry.js";

export const QuotePreviewAgentView: AgentViewComponent = ({ view }) => {
  if (!isQuotePreviewView(view)) return null;
  return <QuotePreviewView view={view} />;
};

export const quotesAgentViews: Record<string, AgentViewComponent> = {
  quote_preview: QuotePreviewAgentView,
};
